import React from 'react';
import { Home, Info, Briefcase, Users, Mail, Zap } from 'lucide-react';
import { TubelightNavbar } from './ui/TubelightNavbar';

const Navbar = () => {
  const navItems = [
    { name: 'Home', url: '#home', icon: Home },
    { name: 'About', url: '#about', icon: Info },
    { name: 'Technologies', url: '#technologies', icon: Zap },
    { name: 'Projects', url: '#projects', icon: Briefcase },
    { name: 'Team', url: '#team', icon: Users },
    { name: 'Contact', url: '#contact', icon: Mail }
  ];

  return <TubelightNavbar items={navItems} />;
};

export default Navbar;
